import { connect } from 'react-redux'
import HamburgerMenu from './components/HamburgerMenu'
import { getSubheaderName } from '../MainMenu/module/mainmenu'

const mapDispatchToProps = {
  getSubheaderName
}

const mapStateToProps = (state) => ({
  name: state.mainmenu.name
})

export default connect(mapStateToProps, mapDispatchToProps)(HamburgerMenu)


// WEBPACK FOOTER //
// ./src/layouts/Layout/HamburgerMenu/index.js